import {bymoTemplateMetadataFactoryCreate} from '../../../doppe-sdk';
import {
    BymoPageHasSearchProps,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    BymoPageSocialLinksProps
} from '../../../client-server-common';
import {
    DoppeHideableValue,
    doppeHideableValueCreateHidden
} from '../../../client-server-common/types/doppe-hideable-value';
import {
    BymoTemplateSpeedDialActionsListAppearance,
    BymoTemplateSpeedDialAutoComplete,
    BymoTemplateSpeedDialHeaderAppearance,
    BymoTemplateSpeedDialSearchAppearance,
    BymoTemplateSpeedDialSocialLinksAppearance
} from './bymo-template-speed-dial-common';

export namespace BymoTemplateSpeedDial {

    export interface TemplateProps extends BymoPageSocialLinksProps , BymoPageHasSearchProps {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete;
        showFullScreenAutoCompleteOnMobile: boolean;
        actionsHeading: DoppeHideableValue<string>;
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance;
        bioText: DoppeHideableValue<string>;
        bioTextMaxLines: DoppeHideableValue<number>;
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance;
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance;
    }
}

const TemplatePropsDefaultValues = () => {
    return {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputSearch as BymoTemplateSpeedDialAutoComplete,
        showFullScreenAutoCompleteOnMobile: false,
        showActionsInSearch: false,
        showLinksInSearch: true,
        actionsHeading: '',
        bioText: '',
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance.Visible as BymoTemplateSpeedDialActionsListAppearance,

        socialLinks: [],
        bioTextMaxLines: doppeHideableValueCreateHidden(3),
        searchAppearance: BymoTemplateSpeedDialSearchAppearance.Hidden ,
        searchPlaceholder: doppeHideableValueCreateHidden(""),
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance.Default ,
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default ,
    } as BymoTemplateSpeedDial.TemplateProps;
}


export const BymoTemplateSpeedDialTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateSpeedDial.TemplateProps>()({
    initialValues: TemplatePropsDefaultValues(),
    resolveProps: props => {
      const {
            ...restProps
        } = props;

        return {
            ...TemplatePropsDefaultValues(),
            socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default,
            ...restProps
        }
    },
    templatePropsMetadata: {
        bioText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        actionsHeading: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        searchPlaceholder: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
    },
    features: [
        'hasActionButton',
        'hasProfileContent',
        'hasVisibleBackground',
        'hasCustomTextualContent',
        'hasActions',        // ✅ Single-page support
        'canBeSkipped',
    ]
})